import React from "react";
import { Container } from "react-bootstrap";
import Header from "../Includes/Header";
import Footer from "../Includes/Footer";
import "../../App.css";

const RiskFactors: React.FC = () => {
  return (
    <>
      <Header />
      <Container className="py-5 mt-4" style={{ maxWidth: 820 }}>
        <h1 className="fw-bold mb-1">Risk Factors</h1>
        <p className="text-secondary small mb-1">Last updated: August 2026</p>
        <p className="text-secondary small mb-5" style={{ lineHeight: 1.7 }}>
          ARM Financial Services Pty Ltd ("ARMF", "we", "us", or "our") · ABN 35 659 595 570 · ACN 659 595 570
          <br />
          Registered with AUSTRAC to provide remittance services in Australia (AAN 100812026, Registered Entity No. 75630)
        </p>

        <Section title="1. Purpose">
          This page sets out key risks associated with using ARMF's remittance, multi-currency
          account, and payment services, particularly relevant to business (entity) customers.
          It should be read alongside our <a href="/terms-of-service">Terms of Service</a>.
        </Section>

        <Section title="2. ARMF Is Not a Bank">
          <strong>ARMF is not an authorised deposit-taking institution (ADI) and is not licensed
          to accept deposits.</strong> Funds you hold or transact through ARMF are not covered by
          the Financial Claims Scheme or any equivalent government deposit guarantee.
        </Section>

        <Section title="3. Foreign Exchange Risk">
          Where a transaction involves a currency conversion, exchange rates can move between the
          time you initiate a transaction and the time it settles. ARMF does not guarantee any
          particular exchange rate outcome.
        </Section>

        <Section title="4. Service Availability Risk">
          Access to our services depends on your location, ongoing regulatory approvals, and
          third-party infrastructure (including banking, payment, and identity-verification
          partners). Service availability, transaction limits, or supported countries and
          currencies may change.
        </Section>

        <Section title="5. Correspondent &amp; Counterparty Risk">
          Remittance transactions often rely on correspondent banks and payment partners in the
          destination country. Delays, reversals, or failures caused by those third parties are
          outside ARMF's direct control, though we will assist you where we reasonably can.
        </Section>

        <Section title="6. Country &amp; Regulatory Restrictions">
          ARMF cannot provide services to, or process transactions involving, certain countries
          or persons subject to Australian or international sanctions, as described on our{" "}
          <a href="/global-availability">Global Service Availability</a> page. These restrictions
          may change without notice in response to regulatory or sanctions developments.
        </Section>

        <Section title="7. No Investment Advice">
          ARMF does not provide investment, tax, or legal advice. Nothing on our platform should
          be construed as a recommendation, and any decision to use our services should take
          your own circumstances into account.
        </Section>

        <Section title="8. Contact Us">
          If you have questions about these risk factors, please contact us at{" "}
          <a href="mailto:support@armf.com">support@armf.com</a>.
        </Section>
      </Container>
      <Footer full={true} />
    </>
  );
};

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="mb-4">
    <h5 className="fw-semibold mb-2">{title}</h5>
    <div className="text-secondary" style={{ lineHeight: 1.8 }}>{children}</div>
  </div>
);

export default RiskFactors;
